import AccessTokenDTO from "@/models/AccessTokenDTO";
import TokenGetRequestDTO from "@/models/request/TokenGetRequestDTO";
import {apiAxios} from "@/service/APIClient";
import TokenOAuthRequestDTO from "@/models/request/TokenOAuthRequestDTO";
import RegisterRequestDTO from "@/models/request/RegisterRequestDTO";
import RegisterResultDTO from "@/models/RegisterResultDTO";

export const token = {
    register: async (credentials: RegisterRequestDTO): Promise<RegisterResultDTO> => {
        let resp = await apiAxios({
            url: `/token/register`,
            data: credentials,
            method: 'POST',
            headers: {
                'Authorization': ''
            }
        })

        return resp.data as RegisterResultDTO
    },
    resendVerification: async (email: string): Promise<void> => {
        await apiAxios({
            url: `/token/resend-verification`,
            data: {email},
            method: 'POST',
            headers: {
                'Authorization': ''
            }
        })
    },
    verifyEmail: async (token: string): Promise<AccessTokenDTO> => {
        let resp = await apiAxios({
            url: `/token/verify-email/${token}`,
            method: 'GET',
            headers: {
                'Authorization': ''
            }
        })

        return resp.data as AccessTokenDTO
    },
    changePassword: async (token: string, password: string): Promise<void> => {
        let resp = await apiAxios({
            url: `/token/change-password/${token}`,
            data: {password},
            method: 'POST',
            headers: {
                'Authorization': ''
            }
        })
    },
    resetPassword: async (username: string): Promise<void> => {
        let resp = await apiAxios({
            url: `/token/reset-password`,
            data: {username},
            method: 'POST',
            headers: {
                'Authorization': ''
            }
        })
    },
    resetPasswordGetToken: async (token: string): Promise<any> => {
        let resp = await apiAxios({
            url: `/token/reset-password/${token}`,
            method: 'GET',
            headers: {
                'Authorization': ''
            }
        })

        return resp.data
    },
    get: async (credentials: TokenGetRequestDTO): Promise<AccessTokenDTO> => {
        let resp = await apiAxios({
            url: `/token/get`,
            data: credentials,
            method: 'POST',
            headers: {
                'Authorization': ''
            }
        })

        return resp.data as AccessTokenDTO
    },
    oauth: async (credentials: TokenOAuthRequestDTO): Promise<AccessTokenDTO> => {
        let resp = await apiAxios({
            url: `/token/oauth`,
            data: credentials,
            method: 'POST',
            headers: {
                'Authorization': ''
            }
        })

        return resp.data as AccessTokenDTO
    },
    oauthConnect: async (credentials: TokenOAuthRequestDTO): Promise<AccessTokenDTO> => {
        let resp = await apiAxios({
            url: `/token/oauth/connect`,
            data: credentials,
            method: 'POST'
        })

        return resp.data as AccessTokenDTO
    },
}